import type { InquiryEntity } from "../../model";

import { SLASH } from "~/shared/str";

const BASE_URL = "inquiries";

const URLS = {
  create: BASE_URL,
  update: BASE_URL,
  delete: (inquiryId: InquiryEntity.Schema["id"]) => [BASE_URL, inquiryId].join(SLASH),
  resolve: [BASE_URL, "resolve"].join(SLASH),
  get: (inquiryId: InquiryEntity.Schema["id"]) => [BASE_URL, inquiryId].join(SLASH),
  getMany: [BASE_URL, "all"].join(SLASH),
  getPaginated: [BASE_URL, "getPage"].join(SLASH),
};

export { URLS };
